export const createStatsData = ({ rows, limit = 8, mapFn, }) => {
    return rows?.slice(0, limit).map((rowData) => mapFn(rowData)) || [];
};
